import { Component, Input,OnInit,Output,EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-pushmessage',
    templateUrl: './pushmessage.component.html',
    styleUrls: ['./pushmessage.component.css']
})
export class PushmessageComponent implements OnInit {

    @Output() pushMessageEmt = new EventEmitter<any>();
    @Input()  select_num: number = 0;

    constructor(public httpClient: HttpClient) {
        const currentDate = new Date();
        this.selectedDateTime = this.formatDateTime(currentDate);
     }

    memo = '';
    title = '';
    content = '';
    inform_method = 1;
    show_popup = 0;
    show_popup1 = 0;
    tmp_img_b64:any = '';
    tmp_img_b641:any = '';
    selectedDateTime: string;
    addroute_sign:any = '-1';
    route_sign:any[] = [
        // { "id": '1', "name": "打開App" },
        // { "id": '2', "name": "探索頁-最新" },
        // { "id": '3', "name": "動態頁-熱門" },
        // { "id": '4', "name": "動態頁-私密話題" },
        // { "id": '5', "name": "動態明細內頁" },
        // { "id": '11', "name": "個人頁" },
        { "id": '1', "name": "打開App" },
        { "id": '2', "name": "探索頁-最新" },
        { "id": '301', "name": "動態頁-關注" },
        { "id": '306', "name": "動態頁-精選" },
        { "id": '5', "name": "動態明細內頁" },
        { "id": '6', "name": "對象聊天室" },
        { "id": '11', "name": "個人頁" },
        { "id": '14', "name": "女性收益報表" },
        { "id": '16', "name": "聊天列表" },
        { "id": '20', "name": "女會員系統頁" },      
    ]

    push_type:any[] = []
    push_type_select = '-1'
    has_sms_url:any = 0

    ngOnInit(): void {
        this.search_type();
    }

    append_text(item){

        this.push_type.forEach(v => {
            if(v.id == item){
                this.title = v.title_tpl;
                this.content = v.content_tpl;
                this.addroute_sign = v.route_sign;
            }
        });

    }

    search_type(){

        const body = {get_type:1};
        this.httpClient.post<any>("/get_push_list_v2.php",body).subscribe(res => {
            if(res.status){
                this.push_type = res.type;
            }
        });




    }



    handleImageUpload(file: File,type:Number): void {

        if(type == 0){
            this.tmp_img_b64 = file;
        }else{
            this.tmp_img_b641 =file;
        }

    }


    private formatDateTime(date: Date): string {

        // 增加 24 小时
        date.setHours(date.getHours() + 24);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        //return `${year}-${month}-${day}T${hours}:${minutes}`;
        return `${year}-${month}-${day} ${hours}:${minutes}:00`;
    }

    send(){

        if(this.title == '' && this.inform_method != 2){

            Swal.fire({
                title: '標題為必填',
                icon: "error"
            });

        }else if(this.content == ''){
            Swal.fire({
                title: '內容為必填',
                icon: "error"
            });
        }else if(this.addroute_sign == '-1'){
            Swal.fire({
                title: 'APP導入頁面必選',
                icon: "error"
            });
        }else{
            let pushMessageData = {
                'title' : this.title,
                'content' : this.content,
                'inform_method' : this.inform_method,
                'show_popup' : this.show_popup,
                'tmp_img_b64' : this.tmp_img_b64,
                'tmp_img_b641' : this.tmp_img_b641,
                'show_popup1' : this.show_popup1,
                'selectedDateTime' : this.selectedDateTime,
                'addroute_sign' : this.addroute_sign,
                'memo'          : this.memo,
                'has_sms_url'   : this.has_sms_url
            };
    
            this.pushMessageEmt.emit(pushMessageData);
        }
      
      
    }

}
